export interface Testimonial {
  quote: string
  name: string
  location: string
  role: string
  initials: string
  time: string
  accent: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Antes quería hacer actividades con mi mamá pero muchas veces no sabía qué hacer. Ahora abro el Mega Pack, elijo una actividad y ya tenemos algo preparado para compartir. 🙌',
    name: 'Mariana Gómez',
    location: 'Buenos Aires',
    role: 'Hija y acompañante familiar',
    initials: 'MG',
    time: '9:41',
    accent: 'text-teal-600',
  },
  {
    quote:
      'Lo que más me gustó es que está todo organizado. Ya no tengo que buscar ideas diferentes todos los días. Simplemente elijo una actividad y la hacemos.',
    name: 'Claudia Pereyra',
    location: 'Córdoba',
    role: 'Familiar acompañante',
    initials: 'CP',
    time: '10:07',
    accent: 'text-gold-600',
  },
  {
    quote:
      'Mi abuela y yo siempre hacíamos lo mismo. Con las actividades empezamos a tener propuestas diferentes para compartir y eso cambió muchísimo nuestras tardes ❤️',
    name: 'Sofía Miranda',
    location: 'Rosario',
    role: 'Nieta y acompañante',
    initials: 'SM',
    time: '13:22',
    accent: 'text-teal-500',
  },
]

export interface RatedTestimonial {
  quote: string
  name: string
  location: string
  role: string
  initials: string
  photo: string
  photoAlt: string
}

export const ratedTestimonials: RatedTestimonial[] = [
  {
    quote:
      'Empezamos con los ejercicios de banda sentada, que es lo que más le sirve a mi mamá. Ahora los hace sola y espera el momento de la actividad.',
    name: 'Alejandra Núñez',
    location: 'San Juan',
    role: 'Hija y acompañante',
    initials: 'AN',
    photo:
      'https://cdn.magicpatterns.com/uploads/vfPnAkrYJvJBv5x18Np9HK/WhatsApp_Image_2026-09-22_at_13.06.19_(1).jpg',
    photoAlt:
      'Mujer mayor sentada realizando un ejercicio con banda elástica en su casa.',
  },
  {
    quote:
      'Trabajo como cuidadora y ahora llego con la actividad del día ya elegida. Armamos el circuito en el living y la jornada se organizó sola.',
    name: 'Verónica Acuña',
    location: 'Mar del Plata',
    role: 'Cuidadora domiciliaria',
    initials: 'VA',
    photo:
      'https://cdn.magicpatterns.com/uploads/12LYHBC39S1HYwXbdQMJF5/WhatsApp_Image_2026-09-22_at_13.28.32_(1).jpg',
    photoAlt:
      'Mujer mayor haciendo un circuito de equilibrio con aros y conos en el living de su casa.',
  },
  {
    quote:
      'El calendario fue lo mejor: abrimos, vemos qué toca y listo. Mi suegra ya pregunta qué actividad hacemos hoy y la hacemos en la galería.',
    name: 'Gabriela Ledesma',
    location: 'La Plata',
    role: 'Hija y acompañante familiar',
    initials: 'GL',
    photo:
      'https://cdn.magicpatterns.com/uploads/fTUuxJZdpw3Ja3nK7zTKZ7/WhatsApp_Image_2026-09-22_at_13.28.32.jpg',
    photoAlt:
      'Mujer mayor con un aro en la mano realizando una actividad de movilidad en la galería de su casa.',
  },
]

export interface PainPoint {
  title: string
  description: string
}

export const painPoints: PainPoint[] = [
  {
    title: '“¿Qué hacemos hoy?”',
    description:
      'Llegás a visitarlo y querés compartir tiempo de calidad, pero no sabés qué actividad proponer.',
  },
  {
    title: 'Siempre hacen lo mismo',
    description:
      'Mate, televisión, celular y conversación. Sentís que podrían aprovechar mejor ese tiempo juntos.',
  },
  {
    title: 'Buscás actividades en Internet',
    description:
      'Encontrás cientos de ideas, pero están desordenadas y perdés muchísimo tiempo buscando algo que realmente puedas hacer.',
  },
  {
    title: 'No tenés tiempo para preparar actividades',
    description:
      'Entre trabajo, casa y responsabilidades, no podés dedicar horas a planificar qué hacer.',
  },
  {
    title: 'Querés mantenerlo activo',
    description:
      'Querés incorporar más movimiento y actividades a su rutina, pero no sabés qué propuestas utilizar.',
  },
  {
    title: 'Querés estimular su mente',
    description:
      'Buscás actividades de memoria, atención, concentración y creatividad que sean sencillas y entretenidas.',
  },
  {
    title: 'Se vuelve difícil variar la rutina',
    description:
      'Después de un tiempo sentís que las opciones se terminan y terminan haciendo siempre lo mismo.',
  },
  {
    title: 'Querés aprovechar mejor el tiempo juntos',
    description:
      'No querés solamente “estar”. Querés compartir momentos, conversar, jugar, crear y hacer actividades juntos.',
  },
]

export interface Audience {
  title: string
  description: string
  badge?: string
}

export const audiences: Audience[] = [
  {
    title: 'Hijos e hijas',
    description:
      'Querés tener actividades preparadas para compartir con tus padres sin tener que improvisar cada vez que los visitás.',
  },
  {
    title: 'Nietos y nietas',
    description:
      'Querés crear momentos diferentes con tus abuelos y encontrar actividades que puedan disfrutar juntos.',
  },
  {
    title: 'Familiares y acompañantes',
    description:
      'Acompañás diariamente a una persona mayor y necesitás nuevas propuestas para romper la rutina.',
    badge: 'NUEVO',
  },
  {
    title: 'Cuidadores',
    description:
      'Buscás recursos prácticos para tener actividades organizadas y listas para utilizar durante tu jornada.',
  },
]

export interface Category {
  title: string
  description: string
  icon: 'brain' | 'dice' | 'move' | 'chat' | 'palette' | 'sparkles' | 'calendar'
}

export const categories: Category[] = [
  {
    title: 'Estimulación de memoria',
    description:
      'Actividades y juegos para trabajar memoria, atención, concentración y asociación.',
    icon: 'brain',
  },
  {
    title: 'Juegos',
    description: 'Propuestas individuales y para compartir en pareja o familia.',
    icon: 'dice',
  },
  {
    title: 'Movimiento',
    description:
      'Actividades sencillas y adaptables para incorporar movimiento a la rutina.',
    icon: 'move',
  },
  {
    title: 'Conversación',
    description: 'Preguntas y dinámicas para generar charlas, recuerdos e historias.',
    icon: 'chat',
  },
  {
    title: 'Creatividad',
    description: 'Dibujo, escritura, música, manualidades y otras propuestas creativas.',
    icon: 'palette',
  },
  {
    title: 'Entretenimiento',
    description: 'Ideas para romper la monotonía y generar nuevos momentos compartidos.',
    icon: 'sparkles',
  },
  {
    title: 'Organización',
    description:
      'Calendarios, planificadores y herramientas para saber qué actividad hacer cada día.',
    icon: 'calendar',
  },
]

export interface Tomo {
  code: string
  title: string
  description: string
  tags: string[]
  cover: string
}

export const tomos: Tomo[] = [
  {
    code: 'T1',
    title: 'Guía del acompañante',
    description:
      'Una guía práctica para entender mejor el rol del acompañante, organizar el día a día y contar con herramientas para brindar un acompañamiento más activo, cercano y organizado.',
    tags: [
      'El rol del acompañante',
      'Organización del día',
      'Herramientas prácticas',
      'Acompañamiento activo',
    ],
    cover:
      'https://cdn.magicpatterns.com/uploads/qURFFyPmuisBgpQ5G9fe8K/WhatsApp_Image_2026-09-21_at_19.26.19.jpg',
  },
  {
    code: 'T2',
    title: 'Movimiento y movilidad',
    description:
      'Actividades y propuestas para incorporar movimiento a la rutina, trabajar la movilidad y mantener una vida cotidiana más activa, siempre adaptando cada propuesta a las posibilidades de la persona.',
    tags: ['Movimiento', 'Movilidad', 'Vida activa', 'Propuestas adaptables'],
    cover:
      'https://cdn.magicpatterns.com/uploads/iVBESrxgxbCtXR7WbnQTEq/WhatsApp_Image_2026-09-21_at_19.26.18.jpg',
  },
  {
    code: 'T3',
    title: 'Fuerza, equilibrio y autonomía',
    description:
      'Ejercicios y actividades orientados a trabajar fuerza, equilibrio y capacidades funcionales que pueden ayudar a conservar la autonomía en las actividades cotidianas.',
    tags: ['Fuerza', 'Equilibrio', 'Capacidades funcionales', 'Autonomía'],
    cover:
      'https://cdn.magicpatterns.com/uploads/7FeyK2Ur5TyoUy91Szc4z9/WhatsApp_Image_2026-09-21_at_19.26.19_(1).jpg',
  },
  {
    code: 'T4',
    title: 'Mente activa',
    description:
      'Una colección de actividades para mantener la mente activa mediante ejercicios de memoria, atención, concentración, razonamiento y diferentes desafíos cognitivos.',
    tags: ['Memoria', 'Atención', 'Concentración', 'Razonamiento', 'Desafíos cognitivos'],
    cover:
      'https://cdn.magicpatterns.com/uploads/pXYtzYnU3oGB4NweiVG4jE/WhatsApp_Image_2026-09-21_at_19.26.19_(2).jpg',
  },
  {
    code: 'T5',
    title: 'Actividades para hacer juntos',
    description:
      'Propuestas pensadas especialmente para compartir. Juegos, dinámicas y actividades que permiten transformar el tiempo juntos en momentos de conexión, entretenimiento y disfrute.',
    tags: ['Juegos', 'Dinámicas', 'Momentos de conexión', 'Entretenimiento'],
    cover:
      'https://cdn.magicpatterns.com/uploads/7wyhAnFKRSudeqc33YLvyK/WhatsApp_Image_2026-09-21_at_19.26.20_(2).jpg',
  },
  {
    code: 'T6',
    title: 'Rutinas listas para usar',
    description:
      'Rutinas prácticas y organizadas para que no tengas que pensar cada día qué hacer. Diferentes propuestas listas para incorporar a la rutina según el momento y las necesidades.',
    tags: ['Rutinas listas', 'Organización', 'Según el momento', 'Sin improvisar'],
    cover:
      'https://cdn.magicpatterns.com/uploads/oUbCHWV6fmNsJeCoqZ2nrQ/WhatsApp_Image_2026-09-21_at_19.26.20.jpg',
  },
  {
    code: 'T7',
    title: 'Calendario de 90 días',
    description:
      'Un calendario completo con propuestas para organizar 90 días de actividades, ayudándote a mantener variedad, constancia y una rutina más activa sin tener que improvisar.',
    tags: ['90 días de propuestas', 'Variedad', 'Constancia', 'Rutina activa'],
    cover:
      'https://cdn.magicpatterns.com/uploads/kk3xggd16WmAwXR48uVLHP/WhatsApp_Image_2026-09-21_at_19.26.20_(1).jpg',
  },
]

export interface Bonus {
  code: string
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    code: 'B1',
    title: 'Evaluación rápida de movilidad',
    description:
      'Herramienta práctica para conocer de manera sencilla el punto de partida de la persona que acompañás y elegir actividades acordes a su nivel actual de movilidad. Incluye una evaluación visual y fácil de completar.',
  },
  {
    code: 'B2',
    title: '“¿Qué hacemos hoy?”',
    description:
      'Guía visual de decisión rápida para elegir una actividad sin tener que revisar todos los tomos cada vez.',
  },
  {
    code: 'B3',
    title: '100 actividades sin equipamiento',
    description:
      'Una biblioteca de 100 actividades organizadas por categoría, para realizar con elementos simples que ya tenés en casa o directamente sin ningún equipamiento especial.',
  },
  {
    code: 'B4',
    title: 'Kit del cuidador',
    description:
      'Cuaderno práctico de organización y seguimiento para familiares y cuidadores: organizá las actividades, registrá lo realizado y tomá notas sobre cómo fue cada día.',
  },
  {
    code: 'B5',
    title: 'Cómo acompañarlo cuando no tiene ganas',
    description:
      'Guía práctica para esos días en los que la persona no tiene ganas, se aburre, se cansa rápido, rechaza una propuesta o prefiere quedarse sentada.',
  },
]

export const withoutPack: string[] = [
  'Buscar actividades cada vez',
  'Repetir siempre lo mismo',
  'Perder tiempo buscando en Internet',
  'No saber qué hacer cada día',
  'Improvisar las actividades',
  'Tener recursos dispersos',
  'No tener una planificación semanal',
  'Terminar haciendo siempre lo mismo',
]

export const withPack: string[] = [
  '+100 actividades organizadas',
  'Nuevas propuestas cada semana',
  'Elegís una actividad en minutos',
  'Calendario de 90 días',
  'Rutinas listas para usar',
  'Todo en un solo lugar',
  'Actividades listas para utilizar',
  'Más variedad para compartir',
]

export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿Cómo recibo el Mega Pack después de comprar?',
    answer:
      'Una vez confirmado el pago recibirás las instrucciones para acceder al contenido digital.',
  },
  {
    question: '¿Puedo usarlo desde el celular?',
    answer: 'Sí. Podés acceder desde celular, tablet o computadora.',
  },
  {
    question: '¿Necesito conocimientos previos?',
    answer:
      'No. Las actividades están pensadas para que puedas elegirlas y realizarlas siguiendo las instrucciones.',
  },
  {
    question: '¿Sirve para acompañar a mis padres o abuelos?',
    answer:
      'Sí. Está pensado para familiares, acompañantes y cuidadores que buscan tener actividades concretas para compartir con adultos mayores.',
  },
  {
    question: '¿Necesito comprar materiales?',
    answer:
      'No. Muchas actividades utilizan elementos simples que normalmente ya tenés en casa.',
  },
  {
    question: '¿Cuánto tiempo duran las actividades?',
    answer:
      'Hay actividades de diferentes duraciones. También incluye propuestas rápidas para momentos en los que tenés poco tiempo.',
  },
  {
    question: '¿Puedo adaptar las actividades?',
    answer:
      'Sí. Las propuestas pueden adaptarse según las posibilidades, intereses y preferencias de cada persona.',
  },
  {
    question: '¿Las actividades reemplazan la atención médica?',
    answer:
      'No. El Mega Pack es un recurso recreativo y educativo y no reemplaza indicaciones, tratamientos ni evaluaciones de profesionales de la salud.',
  },
  {
    question: '¿Los bonos están incluidos?',
    answer: 'Sí. Los 5 bonos están incluidos dentro del Mega Pack sin costo adicional.',
  },
  {
    question: '¿Tiene garantía?',
    answer: 'Sí. Tenés 7 días de garantía según las condiciones de compra.',
  },
]

export const mockupImage =
  'https://cdn.magicpatterns.com/uploads/jTvLSrJi13dDADi8fTYnNk/IMAGEN_DEL_MOKOUP.png'
